module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "admin bump-header"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h1', [_vm._v("No of Users:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.noOfUsers))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h1', [_vm._v("No of Users ONLINE:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.onlineUsers))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11bb0821"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/Overview.vue
// module id = 676
// module chunks = 1